const layerSpeeds: Record<string, number> = {
    background: 0,
    spaceGas: 0,
    stars: 0.2,
    asteroids: 0.3,
    asteroids2: 0,
    paper: 0.5,
    bonkhead: 0,
};

export function getLayerSpeed(name: string): number {
    return layerSpeeds[name] ?? 0;
}

export function getLayerOffset(name: string, offset: number): number {
    const speed = getLayerSpeed(name);
    return speed * offset - speed;
}
